module.exports = __webpack_public_path__ + "static/media/st.00f5130c.svg";